"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSettingsHash = exports.getSettings = exports.getSavedSettingsHash = exports.getPath = exports.getHasChanges = exports.getBasePath = void 0;
var _reselect = require("reselect");
var getSettings = exports.getSettings = function getSettings(state) {
  return state.settings;
};
var getSettingsHash = exports.getSettingsHash = function getSettingsHash(state) {
  return state.settingsHash;
};
var getSavedSettingsHash = exports.getSavedSettingsHash = function getSavedSettingsHash(state) {
  return state.savedSettingsHash;
};
var getBasePath = exports.getBasePath = function getBasePath(state) {
  return state.basePath;
};
var getPath = exports.getPath = function getPath(state) {
  return state.path;
};
var getHasChanges = exports.getHasChanges = (0, _reselect.createSelector)(getSettingsHash, getSavedSettingsHash, function (settingsHash, savedSettingsHash) {
  return settingsHash !== savedSettingsHash;
});